import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  max-width: 440px;
  max-height: 4.4rem;
  border: 0.005rem solid #0f0f0f;
  border-radius: 3rem;
  padding: 0.3rem;
  align-items: center;
`;

export const Input = styled.input`
  border: none;
  font-size: 1.3rem;
  color: #0f0f0f;
  width: 100%;
`;
